import { useParams, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Header } from '../components/layout/Header'

/**
 * ShoppingFeature - Shopping Assistance feature detail page
 */
export function ShoppingFeature() {
  const { t } = useTranslation()
  const { lovedOneId } = useParams<{ lovedOneId: string }>()

  const containerStyles: React.CSSProperties = {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  }

  const contentWrapperStyles: React.CSSProperties = {
    padding: '1.5rem 1rem',
    maxWidth: '600px',
    margin: '0 auto',
  }

  const backLinkStyles: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: '#0066cc',
    textDecoration: 'none',
    fontSize: '14px',
    marginBottom: '1rem',
    minHeight: '44px',
  }

  const titleStyles: React.CSSProperties = {
    fontSize: 'clamp(20px, 4vw, 28px)',
    fontWeight: 700,
    color: '#1a1a1a',
    marginBottom: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  }

  const comingSoonBadgeStyles: React.CSSProperties = {
    display: 'inline-block',
    padding: '0.25rem 0.75rem',
    borderRadius: '9999px',
    fontSize: '12px',
    fontWeight: 500,
    backgroundColor: '#eef2ff',
    color: '#6366f1',
    marginBottom: '1.5rem',
  }

  const cardStyles: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '2rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
  }

  const iconStyles: React.CSSProperties = {
    fontSize: '64px',
    marginBottom: '1rem',
  }

  const descriptionStyles: React.CSSProperties = {
    fontSize: '16px',
    color: '#6b7280',
    lineHeight: 1.6,
  }

  if (!lovedOneId) {
    return (
      <div style={containerStyles}>
        <Header />
        <div style={contentWrapperStyles}>
          <p>Invalid loved one ID</p>
        </div>
      </div>
    )
  }

  return (
    <div style={containerStyles}>
      <Header />
      <div style={contentWrapperStyles}>
        <Link to={`/dashboard/${lovedOneId}`} style={backLinkStyles}>
          ← Back to Dashboard
        </Link>

        <h1 style={titleStyles}>
          <span>🛒</span>
          {t('dashboard.shoppingAssistance')}
        </h1>

        <div style={comingSoonBadgeStyles}>{t('dashboard.comingSoon')}</div>

        <div style={cardStyles}>
          <div style={iconStyles}>🛒</div>
          <p style={descriptionStyles}>
            Shopping Assistance will help your loved one create and manage shopping lists through
            conversations with Little Sister. This feature is currently in development.
          </p>
        </div>
      </div>
    </div>
  )
}
